import { render, staticRenderFns } from "./CustomersByFidelization.vue?vue&type=template&id=191e4804"
import script from "./CustomersByFidelization.vue?vue&type=script&lang=js"
export * from "./CustomersByFidelization.vue?vue&type=script&lang=js"
import style0 from "./CustomersByFidelization.vue?vue&type=style&index=0&id=191e4804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports